var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkInactive = function SvgBookmarkInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "M3.76 13.726v-5.31A3.667 3.667 0 0 1 7.427 4.75h2.906A3.667 3.667 0 0 1 14 8.417v8.551a.917.917 0 0 1-1.412.77l-2.716-1.745a1.833 1.833 0 0 0-1.983 0l-2.716 1.746a.917.917 0 0 1-1.413-.771V13.71"
  })));
};
export default SvgBookmarkInactive;